import { render, staticRenderFns } from "./contacts-communication.vue?vue&type=template&id=0e1803fb&scoped=true"
import script from "./contacts-communication.vue?vue&type=script&lang=js"
export * from "./contacts-communication.vue?vue&type=script&lang=js"
import style0 from "./contacts-communication.vue?vue&type=style&index=0&id=0e1803fb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1803fb",
  null
  
)

export default component.exports